import {
  Badge,
  BadgeColors,
  Icon,
  icons,
  IconText,
  Link,
} from '../../../generic';
import type { Repository } from '../../../../types';

import styles from './RowTitle.module.less';

type RowTitleProps = { repo: Repository };

const RowTitle = ({ repo }: RowTitleProps) =>
  <span className={styles.title}>
    <Link
      to={repo.url as string}
      openInNewTab
      shouldStopPropagation
    >
      {repo.title}
      {repo.isFork && <Icon icon={icons.codeFork} />}
      {repo.isPrivate && <Badge color={BadgeColors.LightGray}><IconText icon={icons.lockOutline} text="Private" /></Badge>}
    </Link>
    &nbsp;&nbsp;
  </span>;

export default RowTitle;
